import '../scss/main.scss';
import './react/agenda';

import Nav from './components/Nav';
import LoadImage from './components/LoadImage';
import Accordion from './components/Accordion';
import Stack from './components/Stack';
import IsDraggable from './components/IsDraggable';
import HideOnScroll from './components/HideOnScroll';
import Carousel from './components/Carousel';
import VideoPlayer from './components/VideoPlayer';
import ServicesLink from './components/ServicesLink';
import LangSwitch from './components/LangSwitch';
import EagerlyMailSubscription from './components/EagerlyMailSubscription';
import Autoplay from './components/Autoplay';
import ThemeToggle from './components/ThemeToggle';
import FormLabels from './components/FormLabels';

import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// Debounce
function debounce(func, time = 100){
	let timer;
	return function(event){
		 if (timer) clearTimeout(timer);
		 timer = setTimeout(func, time, event);
	};
}

document.querySelectorAll('.js-newsletter').forEach((el) => new EagerlyMailSubscription(el));

document.querySelectorAll('.js-autoplay').forEach((el) => {
	new Autoplay(el);
 });

document.querySelectorAll('.js-nav').forEach((el) => {
  new Nav(el);
});

document.querySelectorAll('.js-lang-switch').forEach((el) => {
	new LangSwitch(el);
 });

document.querySelectorAll('.js-load-image').forEach((el) => {
  new LoadImage(el);
});

document.querySelectorAll('.js-accordion').forEach((el) => {
  new Accordion(el);
});

document.querySelectorAll('.js-stack').forEach((el) => {
  new Stack(el);
});

document.querySelectorAll('.js-is-draggable').forEach((el) => {
  new IsDraggable(el);
});

document.querySelectorAll('.js-hide-on-scroll').forEach((el) => {
  new HideOnScroll(el);
});

document.querySelectorAll('.js-carousel').forEach((el) => {
	new Carousel(el);
 });

document.querySelectorAll('.js-video-player').forEach((el) => {
	new VideoPlayer(el);
});

document.querySelectorAll('.js-service').forEach((el) => {
	new ServicesLink(el);
});

document.querySelectorAll('.js-theme-toggle').forEach((el) => {
	new ThemeToggle(el);
 });

// Initialize FormLabels for forms with sublabels
document.addEventListener('DOMContentLoaded', () => {
	FormLabels.initializeWithRetry();
});

window.addEventListener("resize", debounce( () => {ScrollTrigger.refresh()}));
